const DEFAULT_FIELDS = {
  deliveryWindow: "Delivery Window",
  eta: "ETA",
  etd: "ETD",
};

const FFE_FIELDS = {
  deliveryWindow: "Service Window",
  eta: "Est Arrival",
  etd: "Est Departure",
};

const getClientSpecificFieldName = (isFFEConfig) => {
  return isFFEConfig ? FFE_FIELDS : DEFAULT_FIELDS;
};

export { getClientSpecificFieldName };
